module.exports = __webpack_public_path__ + "static/logo_new.764d9eaa.png";